import "./Footer.css"

const Footer = () => {
    return(
        <div className="footer__container">
           <span> © 2020 Knou. All rights reserved</span> 
        </div>
    )
};

export default Footer;